import type {
  LogErrorInput as SharedLogErrorInput,
  LogErrorResult as SharedLogErrorResult,
} from 'types/models/ErrorTracking';

export type LogErrorParams = SharedLogErrorInput;
export type LogErrorResult = SharedLogErrorResult;

export const logError = async (
  params: LogErrorParams
): Promise<LogErrorResult> => {
  // Client-only logging via API to avoid bundling server modules.
  try {
    const response = await fetch('/api/errors/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      keepalive: true,
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    return (await response.json()) as LogErrorResult;
  } catch {
    // Ensure the caller still receives a result even if logging fails client-side
    return {
      errorId: 'client-unsent',
      occurrenceId: null,
      isDuplicate: false,
    };
  }
};
